// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.15.3
//   protoc               v7.36.2
// source: proto/logiblocks/node_run_report.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { DateTimeValue, DayOfWeekSet, SpecificDateSet, VariableValue } from "./logiblocks";

export const protobufPackage = "protobuf.logiblocks";

/** Whether a Delay waited, and if not, why it moved on to its children without waiting. */
export enum DelaySkippedReason {
  /**
   * DELAY_SKIPPED_REASON_UNSPECIFIED - The proto3 default for an unset field. The Delay sets a reason on every DelayReport it
   * writes, so a report holding this value is malformed.
   */
  DELAY_SKIPPED_REASON_UNSPECIFIED = 0,
  /** DELAY_SKIPPED_REASON_NOT_SKIPPED - The Delay waited until its target time. */
  DELAY_SKIPPED_REASON_NOT_SKIPPED = 1,
  /** DELAY_SKIPPED_REASON_SKIP_DELAYS - Skip delays in a test run moved the run's clock to the target time. */
  DELAY_SKIPPED_REASON_SKIP_DELAYS = 2,
  /** DELAY_SKIPPED_REASON_LOCATION_OPEN - The rest are for a Delay until location opens. */
  DELAY_SKIPPED_REASON_LOCATION_OPEN = 3,
  DELAY_SKIPPED_REASON_NO_HOURS_SET = 4,
  DELAY_SKIPPED_REASON_LOCATION_NOT_FOUND = 5,
  DELAY_SKIPPED_REASON_NO_OPENING_AHEAD = 6,
  UNRECOGNIZED = -1,
}

export function delaySkippedReasonFromJSON(object: any): DelaySkippedReason {
  switch (object) {
    case 0:
    case "DELAY_SKIPPED_REASON_UNSPECIFIED":
      return DelaySkippedReason.DELAY_SKIPPED_REASON_UNSPECIFIED;
    case 1:
    case "DELAY_SKIPPED_REASON_NOT_SKIPPED":
      return DelaySkippedReason.DELAY_SKIPPED_REASON_NOT_SKIPPED;
    case 2:
    case "DELAY_SKIPPED_REASON_SKIP_DELAYS":
      return DelaySkippedReason.DELAY_SKIPPED_REASON_SKIP_DELAYS;
    case 3:
    case "DELAY_SKIPPED_REASON_LOCATION_OPEN":
      return DelaySkippedReason.DELAY_SKIPPED_REASON_LOCATION_OPEN;
    case 4:
    case "DELAY_SKIPPED_REASON_NO_HOURS_SET":
      return DelaySkippedReason.DELAY_SKIPPED_REASON_NO_HOURS_SET;
    case 5:
    case "DELAY_SKIPPED_REASON_LOCATION_NOT_FOUND":
      return DelaySkippedReason.DELAY_SKIPPED_REASON_LOCATION_NOT_FOUND;
    case 6:
    case "DELAY_SKIPPED_REASON_NO_OPENING_AHEAD":
      return DelaySkippedReason.DELAY_SKIPPED_REASON_NO_OPENING_AHEAD;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DelaySkippedReason.UNRECOGNIZED;
  }
}

export function delaySkippedReasonToJSON(object: DelaySkippedReason): string {
  switch (object) {
    case DelaySkippedReason.DELAY_SKIPPED_REASON_UNSPECIFIED:
      return "DELAY_SKIPPED_REASON_UNSPECIFIED";
    case DelaySkippedReason.DELAY_SKIPPED_REASON_NOT_SKIPPED:
      return "DELAY_SKIPPED_REASON_NOT_SKIPPED";
    case DelaySkippedReason.DELAY_SKIPPED_REASON_SKIP_DELAYS:
      return "DELAY_SKIPPED_REASON_SKIP_DELAYS";
    case DelaySkippedReason.DELAY_SKIPPED_REASON_LOCATION_OPEN:
      return "DELAY_SKIPPED_REASON_LOCATION_OPEN";
    case DelaySkippedReason.DELAY_SKIPPED_REASON_NO_HOURS_SET:
      return "DELAY_SKIPPED_REASON_NO_HOURS_SET";
    case DelaySkippedReason.DELAY_SKIPPED_REASON_LOCATION_NOT_FOUND:
      return "DELAY_SKIPPED_REASON_LOCATION_NOT_FOUND";
    case DelaySkippedReason.DELAY_SKIPPED_REASON_NO_OPENING_AHEAD:
      return "DELAY_SKIPPED_REASON_NO_OPENING_AHEAD";
    case DelaySkippedReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ConditionOutcome {
  /**
   * CONDITION_OUTCOME_UNSPECIFIED - The proto3 default for an unset field. The Conditional sets an outcome on every
   * ConditionReport it writes, so a report holding this value is malformed.
   */
  CONDITION_OUTCOME_UNSPECIFIED = 0,
  CONDITION_OUTCOME_PASSED = 1,
  CONDITION_OUTCOME_FAILED = 2,
  /** CONDITION_OUTCOME_NOT_EVALUATED - Skipped by short-circuiting: an earlier condition already decided the group. */
  CONDITION_OUTCOME_NOT_EVALUATED = 3,
  UNRECOGNIZED = -1,
}

export function conditionOutcomeFromJSON(object: any): ConditionOutcome {
  switch (object) {
    case 0:
    case "CONDITION_OUTCOME_UNSPECIFIED":
      return ConditionOutcome.CONDITION_OUTCOME_UNSPECIFIED;
    case 1:
    case "CONDITION_OUTCOME_PASSED":
      return ConditionOutcome.CONDITION_OUTCOME_PASSED;
    case 2:
    case "CONDITION_OUTCOME_FAILED":
      return ConditionOutcome.CONDITION_OUTCOME_FAILED;
    case 3:
    case "CONDITION_OUTCOME_NOT_EVALUATED":
      return ConditionOutcome.CONDITION_OUTCOME_NOT_EVALUATED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConditionOutcome.UNRECOGNIZED;
  }
}

export function conditionOutcomeToJSON(object: ConditionOutcome): string {
  switch (object) {
    case ConditionOutcome.CONDITION_OUTCOME_UNSPECIFIED:
      return "CONDITION_OUTCOME_UNSPECIFIED";
    case ConditionOutcome.CONDITION_OUTCOME_PASSED:
      return "CONDITION_OUTCOME_PASSED";
    case ConditionOutcome.CONDITION_OUTCOME_FAILED:
      return "CONDITION_OUTCOME_FAILED";
    case ConditionOutcome.CONDITION_OUTCOME_NOT_EVALUATED:
      return "CONDITION_OUTCOME_NOT_EVALUATED";
    case ConditionOutcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * What a node did during one run, stored on its WorkflowRunNodeStatus row. A report holds only
 * what the run produced; the reader gets the node's settings from the graph that ran.
 */
export interface NodeRunReport {
  conditional?: ConditionalReport | undefined;
  alert_trigger?: AlertTriggerReport | undefined;
  alert_action_taken_trigger?: AlertActionTakenTriggerReport | undefined;
  eta_change_trigger?: EtaChangeTriggerReport | undefined;
  inbound_event_trigger?: InboundEventTriggerReport | undefined;
  inbound_call_trigger?: InboundCallTriggerReport | undefined;
  inbound_trigger?: InboundTriggerReport | undefined;
  manual_execution_trigger?: ManualExecutionTriggerReport | undefined;
  schedule_trigger?: ScheduleTriggerReport | undefined;
  schedule_trigger_v2?: ScheduleTriggerV2Report | undefined;
  status_progress_trigger?: StatusProgressTriggerReport | undefined;
  location_trigger?: LocationTriggerReport | undefined;
  alert_status_check?: AlertStatusCheckReport | undefined;
  delay_action?: DelayReport | undefined;
}

/** The alert an Alert status check read, and its status. */
export interface AlertStatusCheckReport {
  alert_id: string;
  /**
   * An `AlertStatus` value (`variable_enums.py`), the same value the node publishes as
   * `alert_status`.
   */
  status: string;
}

/** When a Delay ends, or why it didn't wait. */
export interface DelayReport {
  /**
   * The time the Delay waits until, on the run's clock. Set when the Delay waited, and when Skip
   * delays moved the clock to it.
   */
  target_time: DateTimeValue | undefined;
  delay_skipped_reason: DelaySkippedReason;
}

/**
 * The alert that started an alert-triggered run, as it was when the trigger fired, and its
 * shipment.
 */
export interface AlertTriggerReport {
  alert_id: string;
  alert_type: string;
  title: string;
  current_value: string;
  current_unit: string;
  threshold_value: string;
  shipment_sensor_id: string;
  shipment_id: string;
  shipment_reference_number: string;
  shipment_courier_name: string;
}

/**
 * The remaining trigger reports have no fields yet. Each trigger type has its own message so it
 * can add detail without changing NodeRunReport.
 */
export interface AlertActionTakenTriggerReport {
}

export interface EtaChangeTriggerReport {
}

export interface InboundEventTriggerReport {
}

export interface InboundCallTriggerReport {
}

export interface InboundTriggerReport {
}

export interface ManualExecutionTriggerReport {
}

export interface ScheduleTriggerReport {
}

export interface ScheduleTriggerV2Report {
}

export interface StatusProgressTriggerReport {
}

export interface LocationTriggerReport {
}

/** How a Conditional node evaluated its conditions. */
export interface ConditionalReport {
  /** Whether the conditions passed, so the node's children ran. */
  passed: boolean;
  /** The report for ConditionalData.root. */
  root: ConditionGroupReport | undefined;
}

/**
 * How one BoolExprGroup evaluated. `conditions[i]` reports on the group's `expressions[i]`, so
 * every expression has an entry, including those skipped by short-circuiting.
 */
export interface ConditionGroupReport {
  conditions: ConditionReport[];
}

/** How one BoolExpr evaluated. */
export interface ConditionReport {
  outcome: ConditionOutcome;
  /**
   * The value the condition's left-hand variable held when the condition was checked. Unset if
   * the variable had no value, the condition wasn't evaluated, or the condition is a group.
   */
  variable_value: VariableValue | undefined;
  group?: ConditionGroupReport | undefined;
  comparison?: ComparisonReport | undefined;
  date_time_set?: DateTimeSetReport | undefined;
}

/**
 * The right-hand values a ComparisonExpr compared against, as the run resolved them. Each is set
 * when its side (`rhs`, `rhs2`) resolved to a value, including a literal. A list
 * right-hand side, for IN_LIST or a multi-select CONTAINS, is in the graph.
 */
export interface ComparisonReport {
  rhs_value: VariableValue | undefined;
  rhs2_value: VariableValue | undefined;
}

/**
 * What a DateTimeSetExpr's set resolved to when it was checked. A preset or saved list can change
 * after the run, so its entries are kept here.
 */
export interface DateTimeSetReport {
  /**
   * Whether the set's source resolved. If not, the condition failed and the other fields are
   * unset.
   */
  resolved: boolean;
  /** The set's name: the preset's or saved list's name, or the inline set's label. */
  name: string;
  /** The IANA zone the variable's value was checked in. Holiday presets use the company's zone. */
  iana_timezone: string;
  /** How many entries the set had. */
  entry_count: number;
  specific_dates?: SpecificDateSet | undefined;
  days_of_week?: DayOfWeekSet | undefined;
}

function createBaseNodeRunReport(): NodeRunReport {
  return {
    conditional: undefined,
    alert_trigger: undefined,
    alert_action_taken_trigger: undefined,
    eta_change_trigger: undefined,
    inbound_event_trigger: undefined,
    inbound_call_trigger: undefined,
    inbound_trigger: undefined,
    manual_execution_trigger: undefined,
    schedule_trigger: undefined,
    schedule_trigger_v2: undefined,
    status_progress_trigger: undefined,
    location_trigger: undefined,
    alert_status_check: undefined,
    delay_action: undefined,
  };
}

export const NodeRunReport: MessageFns<NodeRunReport> = {
  encode(message: NodeRunReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.conditional !== undefined) {
      ConditionalReport.encode(message.conditional, writer.uint32(10).fork()).join();
    }
    if (message.alert_trigger !== undefined) {
      AlertTriggerReport.encode(message.alert_trigger, writer.uint32(18).fork()).join();
    }
    if (message.alert_action_taken_trigger !== undefined) {
      AlertActionTakenTriggerReport.encode(message.alert_action_taken_trigger, writer.uint32(26).fork()).join();
    }
    if (message.eta_change_trigger !== undefined) {
      EtaChangeTriggerReport.encode(message.eta_change_trigger, writer.uint32(34).fork()).join();
    }
    if (message.inbound_event_trigger !== undefined) {
      InboundEventTriggerReport.encode(message.inbound_event_trigger, writer.uint32(42).fork()).join();
    }
    if (message.inbound_call_trigger !== undefined) {
      InboundCallTriggerReport.encode(message.inbound_call_trigger, writer.uint32(50).fork()).join();
    }
    if (message.inbound_trigger !== undefined) {
      InboundTriggerReport.encode(message.inbound_trigger, writer.uint32(58).fork()).join();
    }
    if (message.manual_execution_trigger !== undefined) {
      ManualExecutionTriggerReport.encode(message.manual_execution_trigger, writer.uint32(66).fork()).join();
    }
    if (message.schedule_trigger !== undefined) {
      ScheduleTriggerReport.encode(message.schedule_trigger, writer.uint32(74).fork()).join();
    }
    if (message.schedule_trigger_v2 !== undefined) {
      ScheduleTriggerV2Report.encode(message.schedule_trigger_v2, writer.uint32(82).fork()).join();
    }
    if (message.status_progress_trigger !== undefined) {
      StatusProgressTriggerReport.encode(message.status_progress_trigger, writer.uint32(90).fork()).join();
    }
    if (message.location_trigger !== undefined) {
      LocationTriggerReport.encode(message.location_trigger, writer.uint32(98).fork()).join();
    }
    if (message.alert_status_check !== undefined) {
      AlertStatusCheckReport.encode(message.alert_status_check, writer.uint32(106).fork()).join();
    }
    if (message.delay_action !== undefined) {
      DelayReport.encode(message.delay_action, writer.uint32(114).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodeRunReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseNodeRunReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.conditional = ConditionalReport.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.alert_trigger = AlertTriggerReport.decode(reader, reader.uint32());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.alert_action_taken_trigger = AlertActionTakenTriggerReport.decode(reader, reader.uint32());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.eta_change_trigger = EtaChangeTriggerReport.decode(reader, reader.uint32());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.inbound_event_trigger = InboundEventTriggerReport.decode(reader, reader.uint32());
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.inbound_call_trigger = InboundCallTriggerReport.decode(reader, reader.uint32());
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.inbound_trigger = InboundTriggerReport.decode(reader, reader.uint32());
            continue;
          }
          case 8: {
            if (tag !== 66) {
              break;
            }

            message.manual_execution_trigger = ManualExecutionTriggerReport.decode(reader, reader.uint32());
            continue;
          }
          case 9: {
            if (tag !== 74) {
              break;
            }

            message.schedule_trigger = ScheduleTriggerReport.decode(reader, reader.uint32());
            continue;
          }
          case 10: {
            if (tag !== 82) {
              break;
            }

            message.schedule_trigger_v2 = ScheduleTriggerV2Report.decode(reader, reader.uint32());
            continue;
          }
          case 11: {
            if (tag !== 90) {
              break;
            }

            message.status_progress_trigger = StatusProgressTriggerReport.decode(reader, reader.uint32());
            continue;
          }
          case 12: {
            if (tag !== 98) {
              break;
            }

            message.location_trigger = LocationTriggerReport.decode(reader, reader.uint32());
            continue;
          }
          case 13: {
            if (tag !== 106) {
              break;
            }

            message.alert_status_check = AlertStatusCheckReport.decode(reader, reader.uint32());
            continue;
          }
          case 14: {
            if (tag !== 114) {
              break;
            }

            message.delay_action = DelayReport.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): NodeRunReport {
    return {
      conditional: isSet(object.conditional) ? ConditionalReport.fromJSON(object.conditional) : undefined,
      alert_trigger: isSet(object.alertTrigger)
        ? AlertTriggerReport.fromJSON(object.alertTrigger)
        : isSet(object.alert_trigger)
        ? AlertTriggerReport.fromJSON(object.alert_trigger)
        : undefined,
      alert_action_taken_trigger: isSet(object.alertActionTakenTrigger)
        ? AlertActionTakenTriggerReport.fromJSON(object.alertActionTakenTrigger)
        : isSet(object.alert_action_taken_trigger)
        ? AlertActionTakenTriggerReport.fromJSON(object.alert_action_taken_trigger)
        : undefined,
      eta_change_trigger: isSet(object.etaChangeTrigger)
        ? EtaChangeTriggerReport.fromJSON(object.etaChangeTrigger)
        : isSet(object.eta_change_trigger)
        ? EtaChangeTriggerReport.fromJSON(object.eta_change_trigger)
        : undefined,
      inbound_event_trigger: isSet(object.inboundEventTrigger)
        ? InboundEventTriggerReport.fromJSON(object.inboundEventTrigger)
        : isSet(object.inbound_event_trigger)
        ? InboundEventTriggerReport.fromJSON(object.inbound_event_trigger)
        : undefined,
      inbound_call_trigger: isSet(object.inboundCallTrigger)
        ? InboundCallTriggerReport.fromJSON(object.inboundCallTrigger)
        : isSet(object.inbound_call_trigger)
        ? InboundCallTriggerReport.fromJSON(object.inbound_call_trigger)
        : undefined,
      inbound_trigger: isSet(object.inboundTrigger)
        ? InboundTriggerReport.fromJSON(object.inboundTrigger)
        : isSet(object.inbound_trigger)
        ? InboundTriggerReport.fromJSON(object.inbound_trigger)
        : undefined,
      manual_execution_trigger: isSet(object.manualExecutionTrigger)
        ? ManualExecutionTriggerReport.fromJSON(object.manualExecutionTrigger)
        : isSet(object.manual_execution_trigger)
        ? ManualExecutionTriggerReport.fromJSON(object.manual_execution_trigger)
        : undefined,
      schedule_trigger: isSet(object.scheduleTrigger)
        ? ScheduleTriggerReport.fromJSON(object.scheduleTrigger)
        : isSet(object.schedule_trigger)
        ? ScheduleTriggerReport.fromJSON(object.schedule_trigger)
        : undefined,
      schedule_trigger_v2: isSet(object.scheduleTriggerV2)
        ? ScheduleTriggerV2Report.fromJSON(object.scheduleTriggerV2)
        : isSet(object.schedule_trigger_v2)
        ? ScheduleTriggerV2Report.fromJSON(object.schedule_trigger_v2)
        : undefined,
      status_progress_trigger: isSet(object.statusProgressTrigger)
        ? StatusProgressTriggerReport.fromJSON(object.statusProgressTrigger)
        : isSet(object.status_progress_trigger)
        ? StatusProgressTriggerReport.fromJSON(object.status_progress_trigger)
        : undefined,
      location_trigger: isSet(object.locationTrigger)
        ? LocationTriggerReport.fromJSON(object.locationTrigger)
        : isSet(object.location_trigger)
        ? LocationTriggerReport.fromJSON(object.location_trigger)
        : undefined,
      alert_status_check: isSet(object.alertStatusCheck)
        ? AlertStatusCheckReport.fromJSON(object.alertStatusCheck)
        : isSet(object.alert_status_check)
        ? AlertStatusCheckReport.fromJSON(object.alert_status_check)
        : undefined,
      delay_action: isSet(object.delayAction)
        ? DelayReport.fromJSON(object.delayAction)
        : isSet(object.delay_action)
        ? DelayReport.fromJSON(object.delay_action)
        : undefined,
    };
  },

  toJSON(message: NodeRunReport): unknown {
    const obj: any = {};
    if (message.conditional !== undefined) {
      obj.conditional = ConditionalReport.toJSON(message.conditional);
    }
    if (message.alert_trigger !== undefined) {
      obj.alertTrigger = AlertTriggerReport.toJSON(message.alert_trigger);
    }
    if (message.alert_action_taken_trigger !== undefined) {
      obj.alertActionTakenTrigger = AlertActionTakenTriggerReport.toJSON(message.alert_action_taken_trigger);
    }
    if (message.eta_change_trigger !== undefined) {
      obj.etaChangeTrigger = EtaChangeTriggerReport.toJSON(message.eta_change_trigger);
    }
    if (message.inbound_event_trigger !== undefined) {
      obj.inboundEventTrigger = InboundEventTriggerReport.toJSON(message.inbound_event_trigger);
    }
    if (message.inbound_call_trigger !== undefined) {
      obj.inboundCallTrigger = InboundCallTriggerReport.toJSON(message.inbound_call_trigger);
    }
    if (message.inbound_trigger !== undefined) {
      obj.inboundTrigger = InboundTriggerReport.toJSON(message.inbound_trigger);
    }
    if (message.manual_execution_trigger !== undefined) {
      obj.manualExecutionTrigger = ManualExecutionTriggerReport.toJSON(message.manual_execution_trigger);
    }
    if (message.schedule_trigger !== undefined) {
      obj.scheduleTrigger = ScheduleTriggerReport.toJSON(message.schedule_trigger);
    }
    if (message.schedule_trigger_v2 !== undefined) {
      obj.scheduleTriggerV2 = ScheduleTriggerV2Report.toJSON(message.schedule_trigger_v2);
    }
    if (message.status_progress_trigger !== undefined) {
      obj.statusProgressTrigger = StatusProgressTriggerReport.toJSON(message.status_progress_trigger);
    }
    if (message.location_trigger !== undefined) {
      obj.locationTrigger = LocationTriggerReport.toJSON(message.location_trigger);
    }
    if (message.alert_status_check !== undefined) {
      obj.alertStatusCheck = AlertStatusCheckReport.toJSON(message.alert_status_check);
    }
    if (message.delay_action !== undefined) {
      obj.delayAction = DelayReport.toJSON(message.delay_action);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodeRunReport>, I>>(base?: I): NodeRunReport {
    return NodeRunReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodeRunReport>, I>>(object: I): NodeRunReport {
    const message = createBaseNodeRunReport();
    message.conditional = (object.conditional !== undefined && object.conditional !== null)
      ? ConditionalReport.fromPartial(object.conditional)
      : undefined;
    message.alert_trigger = (object.alert_trigger !== undefined && object.alert_trigger !== null)
      ? AlertTriggerReport.fromPartial(object.alert_trigger)
      : undefined;
    message.alert_action_taken_trigger =
      (object.alert_action_taken_trigger !== undefined && object.alert_action_taken_trigger !== null)
        ? AlertActionTakenTriggerReport.fromPartial(object.alert_action_taken_trigger)
        : undefined;
    message.eta_change_trigger = (object.eta_change_trigger !== undefined && object.eta_change_trigger !== null)
      ? EtaChangeTriggerReport.fromPartial(object.eta_change_trigger)
      : undefined;
    message.inbound_event_trigger =
      (object.inbound_event_trigger !== undefined && object.inbound_event_trigger !== null)
        ? InboundEventTriggerReport.fromPartial(object.inbound_event_trigger)
        : undefined;
    message.inbound_call_trigger = (object.inbound_call_trigger !== undefined && object.inbound_call_trigger !== null)
      ? InboundCallTriggerReport.fromPartial(object.inbound_call_trigger)
      : undefined;
    message.inbound_trigger = (object.inbound_trigger !== undefined && object.inbound_trigger !== null)
      ? InboundTriggerReport.fromPartial(object.inbound_trigger)
      : undefined;
    message.manual_execution_trigger =
      (object.manual_execution_trigger !== undefined && object.manual_execution_trigger !== null)
        ? ManualExecutionTriggerReport.fromPartial(object.manual_execution_trigger)
        : undefined;
    message.schedule_trigger = (object.schedule_trigger !== undefined && object.schedule_trigger !== null)
      ? ScheduleTriggerReport.fromPartial(object.schedule_trigger)
      : undefined;
    message.schedule_trigger_v2 = (object.schedule_trigger_v2 !== undefined && object.schedule_trigger_v2 !== null)
      ? ScheduleTriggerV2Report.fromPartial(object.schedule_trigger_v2)
      : undefined;
    message.status_progress_trigger =
      (object.status_progress_trigger !== undefined && object.status_progress_trigger !== null)
        ? StatusProgressTriggerReport.fromPartial(object.status_progress_trigger)
        : undefined;
    message.location_trigger = (object.location_trigger !== undefined && object.location_trigger !== null)
      ? LocationTriggerReport.fromPartial(object.location_trigger)
      : undefined;
    message.alert_status_check = (object.alert_status_check !== undefined && object.alert_status_check !== null)
      ? AlertStatusCheckReport.fromPartial(object.alert_status_check)
      : undefined;
    message.delay_action = (object.delay_action !== undefined && object.delay_action !== null)
      ? DelayReport.fromPartial(object.delay_action)
      : undefined;
    return message;
  },
};

function createBaseAlertStatusCheckReport(): AlertStatusCheckReport {
  return { alert_id: "", status: "" };
}

export const AlertStatusCheckReport: MessageFns<AlertStatusCheckReport> = {
  encode(message: AlertStatusCheckReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.alert_id !== "") {
      writer.uint32(10).string(message.alert_id);
    }
    if (message.status !== "") {
      writer.uint32(18).string(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlertStatusCheckReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseAlertStatusCheckReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.alert_id = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.status = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): AlertStatusCheckReport {
    return {
      alert_id: isSet(object.alertId)
        ? globalThis.String(object.alertId)
        : isSet(object.alert_id)
        ? globalThis.String(object.alert_id)
        : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
    };
  },

  toJSON(message: AlertStatusCheckReport): unknown {
    const obj: any = {};
    if (message.alert_id !== "") {
      obj.alertId = message.alert_id;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AlertStatusCheckReport>, I>>(base?: I): AlertStatusCheckReport {
    return AlertStatusCheckReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AlertStatusCheckReport>, I>>(object: I): AlertStatusCheckReport {
    const message = createBaseAlertStatusCheckReport();
    message.alert_id = object.alert_id ?? "";
    message.status = object.status ?? "";
    return message;
  },
};

function createBaseDelayReport(): DelayReport {
  return { target_time: undefined, delay_skipped_reason: 0 };
}

export const DelayReport: MessageFns<DelayReport> = {
  encode(message: DelayReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.target_time !== undefined) {
      DateTimeValue.encode(message.target_time, writer.uint32(10).fork()).join();
    }
    if (message.delay_skipped_reason !== 0) {
      writer.uint32(16).int32(message.delay_skipped_reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.target_time = DateTimeValue.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.delay_skipped_reason = reader.int32() as any;
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayReport {
    return {
      target_time: isSet(object.targetTime)
        ? DateTimeValue.fromJSON(object.targetTime)
        : isSet(object.target_time)
        ? DateTimeValue.fromJSON(object.target_time)
        : undefined,
      delay_skipped_reason: isSet(object.delaySkippedReason)
        ? delaySkippedReasonFromJSON(object.delaySkippedReason)
        : isSet(object.delay_skipped_reason)
        ? delaySkippedReasonFromJSON(object.delay_skipped_reason)
        : 0,
    };
  },

  toJSON(message: DelayReport): unknown {
    const obj: any = {};
    if (message.target_time !== undefined) {
      obj.targetTime = DateTimeValue.toJSON(message.target_time);
    }
    if (message.delay_skipped_reason !== 0) {
      obj.delaySkippedReason = delaySkippedReasonToJSON(message.delay_skipped_reason);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayReport>, I>>(base?: I): DelayReport {
    return DelayReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayReport>, I>>(object: I): DelayReport {
    const message = createBaseDelayReport();
    message.target_time = (object.target_time !== undefined && object.target_time !== null)
      ? DateTimeValue.fromPartial(object.target_time)
      : undefined;
    message.delay_skipped_reason = object.delay_skipped_reason ?? 0;
    return message;
  },
};

function createBaseAlertTriggerReport(): AlertTriggerReport {
  return {
    alert_id: "",
    alert_type: "",
    title: "",
    current_value: "",
    current_unit: "",
    threshold_value: "",
    shipment_sensor_id: "",
    shipment_id: "",
    shipment_reference_number: "",
    shipment_courier_name: "",
  };
}

export const AlertTriggerReport: MessageFns<AlertTriggerReport> = {
  encode(message: AlertTriggerReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.alert_id !== "") {
      writer.uint32(10).string(message.alert_id);
    }
    if (message.alert_type !== "") {
      writer.uint32(18).string(message.alert_type);
    }
    if (message.title !== "") {
      writer.uint32(26).string(message.title);
    }
    if (message.current_value !== "") {
      writer.uint32(34).string(message.current_value);
    }
    if (message.current_unit !== "") {
      writer.uint32(42).string(message.current_unit);
    }
    if (message.threshold_value !== "") {
      writer.uint32(50).string(message.threshold_value);
    }
    if (message.shipment_sensor_id !== "") {
      writer.uint32(58).string(message.shipment_sensor_id);
    }
    if (message.shipment_id !== "") {
      writer.uint32(66).string(message.shipment_id);
    }
    if (message.shipment_reference_number !== "") {
      writer.uint32(74).string(message.shipment_reference_number);
    }
    if (message.shipment_courier_name !== "") {
      writer.uint32(82).string(message.shipment_courier_name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlertTriggerReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseAlertTriggerReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.alert_id = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.alert_type = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.title = reader.string();
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.current_value = reader.string();
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.current_unit = reader.string();
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.threshold_value = reader.string();
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.shipment_sensor_id = reader.string();
            continue;
          }
          case 8: {
            if (tag !== 66) {
              break;
            }

            message.shipment_id = reader.string();
            continue;
          }
          case 9: {
            if (tag !== 74) {
              break;
            }

            message.shipment_reference_number = reader.string();
            continue;
          }
          case 10: {
            if (tag !== 82) {
              break;
            }

            message.shipment_courier_name = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): AlertTriggerReport {
    return {
      alert_id: isSet(object.alertId)
        ? globalThis.String(object.alertId)
        : isSet(object.alert_id)
        ? globalThis.String(object.alert_id)
        : "",
      alert_type: isSet(object.alertType)
        ? globalThis.String(object.alertType)
        : isSet(object.alert_type)
        ? globalThis.String(object.alert_type)
        : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      current_value: isSet(object.currentValue)
        ? globalThis.String(object.currentValue)
        : isSet(object.current_value)
        ? globalThis.String(object.current_value)
        : "",
      current_unit: isSet(object.currentUnit)
        ? globalThis.String(object.currentUnit)
        : isSet(object.current_unit)
        ? globalThis.String(object.current_unit)
        : "",
      threshold_value: isSet(object.thresholdValue)
        ? globalThis.String(object.thresholdValue)
        : isSet(object.threshold_value)
        ? globalThis.String(object.threshold_value)
        : "",
      shipment_sensor_id: isSet(object.shipmentSensorId)
        ? globalThis.String(object.shipmentSensorId)
        : isSet(object.shipment_sensor_id)
        ? globalThis.String(object.shipment_sensor_id)
        : "",
      shipment_id: isSet(object.shipmentId)
        ? globalThis.String(object.shipmentId)
        : isSet(object.shipment_id)
        ? globalThis.String(object.shipment_id)
        : "",
      shipment_reference_number: isSet(object.shipmentReferenceNumber)
        ? globalThis.String(object.shipmentReferenceNumber)
        : isSet(object.shipment_reference_number)
        ? globalThis.String(object.shipment_reference_number)
        : "",
      shipment_courier_name: isSet(object.shipmentCourierName)
        ? globalThis.String(object.shipmentCourierName)
        : isSet(object.shipment_courier_name)
        ? globalThis.String(object.shipment_courier_name)
        : "",
    };
  },

  toJSON(message: AlertTriggerReport): unknown {
    const obj: any = {};
    if (message.alert_id !== "") {
      obj.alertId = message.alert_id;
    }
    if (message.alert_type !== "") {
      obj.alertType = message.alert_type;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.current_value !== "") {
      obj.currentValue = message.current_value;
    }
    if (message.current_unit !== "") {
      obj.currentUnit = message.current_unit;
    }
    if (message.threshold_value !== "") {
      obj.thresholdValue = message.threshold_value;
    }
    if (message.shipment_sensor_id !== "") {
      obj.shipmentSensorId = message.shipment_sensor_id;
    }
    if (message.shipment_id !== "") {
      obj.shipmentId = message.shipment_id;
    }
    if (message.shipment_reference_number !== "") {
      obj.shipmentReferenceNumber = message.shipment_reference_number;
    }
    if (message.shipment_courier_name !== "") {
      obj.shipmentCourierName = message.shipment_courier_name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AlertTriggerReport>, I>>(base?: I): AlertTriggerReport {
    return AlertTriggerReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AlertTriggerReport>, I>>(object: I): AlertTriggerReport {
    const message = createBaseAlertTriggerReport();
    message.alert_id = object.alert_id ?? "";
    message.alert_type = object.alert_type ?? "";
    message.title = object.title ?? "";
    message.current_value = object.current_value ?? "";
    message.current_unit = object.current_unit ?? "";
    message.threshold_value = object.threshold_value ?? "";
    message.shipment_sensor_id = object.shipment_sensor_id ?? "";
    message.shipment_id = object.shipment_id ?? "";
    message.shipment_reference_number = object.shipment_reference_number ?? "";
    message.shipment_courier_name = object.shipment_courier_name ?? "";
    return message;
  },
};

function createBaseAlertActionTakenTriggerReport(): AlertActionTakenTriggerReport {
  return {};
}

export const AlertActionTakenTriggerReport: MessageFns<AlertActionTakenTriggerReport> = {
  encode(_: AlertActionTakenTriggerReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlertActionTakenTriggerReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseAlertActionTakenTriggerReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(_: any): AlertActionTakenTriggerReport {
    return {};
  },

  toJSON(_: AlertActionTakenTriggerReport): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AlertActionTakenTriggerReport>, I>>(base?: I): AlertActionTakenTriggerReport {
    return AlertActionTakenTriggerReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AlertActionTakenTriggerReport>, I>>(_: I): AlertActionTakenTriggerReport {
    const message = createBaseAlertActionTakenTriggerReport();
    return message;
  },
};

function createBaseEtaChangeTriggerReport(): EtaChangeTriggerReport {
  return {};
}

export const EtaChangeTriggerReport: MessageFns<EtaChangeTriggerReport> = {
  encode(_: EtaChangeTriggerReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EtaChangeTriggerReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseEtaChangeTriggerReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(_: any): EtaChangeTriggerReport {
    return {};
  },

  toJSON(_: EtaChangeTriggerReport): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<EtaChangeTriggerReport>, I>>(base?: I): EtaChangeTriggerReport {
    return EtaChangeTriggerReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EtaChangeTriggerReport>, I>>(_: I): EtaChangeTriggerReport {
    const message = createBaseEtaChangeTriggerReport();
    return message;
  },
};

function createBaseInboundEventTriggerReport(): InboundEventTriggerReport {
  return {};
}

export const InboundEventTriggerReport: MessageFns<InboundEventTriggerReport> = {
  encode(_: InboundEventTriggerReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboundEventTriggerReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseInboundEventTriggerReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(_: any): InboundEventTriggerReport {
    return {};
  },

  toJSON(_: InboundEventTriggerReport): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<InboundEventTriggerReport>, I>>(base?: I): InboundEventTriggerReport {
    return InboundEventTriggerReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboundEventTriggerReport>, I>>(_: I): InboundEventTriggerReport {
    const message = createBaseInboundEventTriggerReport();
    return message;
  },
};

function createBaseInboundCallTriggerReport(): InboundCallTriggerReport {
  return {};
}

export const InboundCallTriggerReport: MessageFns<InboundCallTriggerReport> = {
  encode(_: InboundCallTriggerReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboundCallTriggerReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseInboundCallTriggerReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(_: any): InboundCallTriggerReport {
    return {};
  },

  toJSON(_: InboundCallTriggerReport): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<InboundCallTriggerReport>, I>>(base?: I): InboundCallTriggerReport {
    return InboundCallTriggerReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboundCallTriggerReport>, I>>(_: I): InboundCallTriggerReport {
    const message = createBaseInboundCallTriggerReport();
    return message;
  },
};

function createBaseInboundTriggerReport(): InboundTriggerReport {
  return {};
}

export const InboundTriggerReport: MessageFns<InboundTriggerReport> = {
  encode(_: InboundTriggerReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboundTriggerReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseInboundTriggerReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(_: any): InboundTriggerReport {
    return {};
  },

  toJSON(_: InboundTriggerReport): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<InboundTriggerReport>, I>>(base?: I): InboundTriggerReport {
    return InboundTriggerReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboundTriggerReport>, I>>(_: I): InboundTriggerReport {
    const message = createBaseInboundTriggerReport();
    return message;
  },
};

function createBaseManualExecutionTriggerReport(): ManualExecutionTriggerReport {
  return {};
}

export const ManualExecutionTriggerReport: MessageFns<ManualExecutionTriggerReport> = {
  encode(_: ManualExecutionTriggerReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManualExecutionTriggerReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseManualExecutionTriggerReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(_: any): ManualExecutionTriggerReport {
    return {};
  },

  toJSON(_: ManualExecutionTriggerReport): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ManualExecutionTriggerReport>, I>>(base?: I): ManualExecutionTriggerReport {
    return ManualExecutionTriggerReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManualExecutionTriggerReport>, I>>(_: I): ManualExecutionTriggerReport {
    const message = createBaseManualExecutionTriggerReport();
    return message;
  },
};

function createBaseScheduleTriggerReport(): ScheduleTriggerReport {
  return {};
}

export const ScheduleTriggerReport: MessageFns<ScheduleTriggerReport> = {
  encode(_: ScheduleTriggerReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScheduleTriggerReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseScheduleTriggerReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(_: any): ScheduleTriggerReport {
    return {};
  },

  toJSON(_: ScheduleTriggerReport): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ScheduleTriggerReport>, I>>(base?: I): ScheduleTriggerReport {
    return ScheduleTriggerReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScheduleTriggerReport>, I>>(_: I): ScheduleTriggerReport {
    const message = createBaseScheduleTriggerReport();
    return message;
  },
};

function createBaseScheduleTriggerV2Report(): ScheduleTriggerV2Report {
  return {};
}

export const ScheduleTriggerV2Report: MessageFns<ScheduleTriggerV2Report> = {
  encode(_: ScheduleTriggerV2Report, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScheduleTriggerV2Report {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseScheduleTriggerV2Report();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(_: any): ScheduleTriggerV2Report {
    return {};
  },

  toJSON(_: ScheduleTriggerV2Report): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ScheduleTriggerV2Report>, I>>(base?: I): ScheduleTriggerV2Report {
    return ScheduleTriggerV2Report.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScheduleTriggerV2Report>, I>>(_: I): ScheduleTriggerV2Report {
    const message = createBaseScheduleTriggerV2Report();
    return message;
  },
};

function createBaseStatusProgressTriggerReport(): StatusProgressTriggerReport {
  return {};
}

export const StatusProgressTriggerReport: MessageFns<StatusProgressTriggerReport> = {
  encode(_: StatusProgressTriggerReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StatusProgressTriggerReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseStatusProgressTriggerReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(_: any): StatusProgressTriggerReport {
    return {};
  },

  toJSON(_: StatusProgressTriggerReport): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<StatusProgressTriggerReport>, I>>(base?: I): StatusProgressTriggerReport {
    return StatusProgressTriggerReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StatusProgressTriggerReport>, I>>(_: I): StatusProgressTriggerReport {
    const message = createBaseStatusProgressTriggerReport();
    return message;
  },
};

function createBaseLocationTriggerReport(): LocationTriggerReport {
  return {};
}

export const LocationTriggerReport: MessageFns<LocationTriggerReport> = {
  encode(_: LocationTriggerReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LocationTriggerReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseLocationTriggerReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(_: any): LocationTriggerReport {
    return {};
  },

  toJSON(_: LocationTriggerReport): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<LocationTriggerReport>, I>>(base?: I): LocationTriggerReport {
    return LocationTriggerReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LocationTriggerReport>, I>>(_: I): LocationTriggerReport {
    const message = createBaseLocationTriggerReport();
    return message;
  },
};

function createBaseConditionalReport(): ConditionalReport {
  return { passed: false, root: undefined };
}

export const ConditionalReport: MessageFns<ConditionalReport> = {
  encode(message: ConditionalReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.passed !== false) {
      writer.uint32(8).bool(message.passed);
    }
    if (message.root !== undefined) {
      ConditionGroupReport.encode(message.root, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConditionalReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseConditionalReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.passed = reader.bool();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.root = ConditionGroupReport.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ConditionalReport {
    return {
      passed: isSet(object.passed) ? globalThis.Boolean(object.passed) : false,
      root: isSet(object.root) ? ConditionGroupReport.fromJSON(object.root) : undefined,
    };
  },

  toJSON(message: ConditionalReport): unknown {
    const obj: any = {};
    if (message.passed !== false) {
      obj.passed = message.passed;
    }
    if (message.root !== undefined) {
      obj.root = ConditionGroupReport.toJSON(message.root);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConditionalReport>, I>>(base?: I): ConditionalReport {
    return ConditionalReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConditionalReport>, I>>(object: I): ConditionalReport {
    const message = createBaseConditionalReport();
    message.passed = object.passed ?? false;
    message.root = (object.root !== undefined && object.root !== null)
      ? ConditionGroupReport.fromPartial(object.root)
      : undefined;
    return message;
  },
};

function createBaseConditionGroupReport(): ConditionGroupReport {
  return { conditions: [] };
}

export const ConditionGroupReport: MessageFns<ConditionGroupReport> = {
  encode(message: ConditionGroupReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.conditions) {
      ConditionReport.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConditionGroupReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseConditionGroupReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.conditions.push(ConditionReport.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ConditionGroupReport {
    return {
      conditions: globalThis.Array.isArray(object?.conditions)
        ? object.conditions.map((e: any) => ConditionReport.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ConditionGroupReport): unknown {
    const obj: any = {};
    if (message.conditions?.length) {
      obj.conditions = message.conditions.map((e) => ConditionReport.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConditionGroupReport>, I>>(base?: I): ConditionGroupReport {
    return ConditionGroupReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConditionGroupReport>, I>>(object: I): ConditionGroupReport {
    const message = createBaseConditionGroupReport();
    message.conditions = object.conditions?.map((e) => ConditionReport.fromPartial(e)) || [];
    return message;
  },
};

function createBaseConditionReport(): ConditionReport {
  return { outcome: 0, variable_value: undefined, group: undefined, comparison: undefined, date_time_set: undefined };
}

export const ConditionReport: MessageFns<ConditionReport> = {
  encode(message: ConditionReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    if (message.variable_value !== undefined) {
      VariableValue.encode(message.variable_value, writer.uint32(18).fork()).join();
    }
    if (message.group !== undefined) {
      ConditionGroupReport.encode(message.group, writer.uint32(26).fork()).join();
    }
    if (message.comparison !== undefined) {
      ComparisonReport.encode(message.comparison, writer.uint32(34).fork()).join();
    }
    if (message.date_time_set !== undefined) {
      DateTimeSetReport.encode(message.date_time_set, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConditionReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseConditionReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.outcome = reader.int32() as any;
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.variable_value = VariableValue.decode(reader, reader.uint32());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.group = ConditionGroupReport.decode(reader, reader.uint32());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.comparison = ComparisonReport.decode(reader, reader.uint32());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.date_time_set = DateTimeSetReport.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ConditionReport {
    return {
      outcome: isSet(object.outcome) ? conditionOutcomeFromJSON(object.outcome) : 0,
      variable_value: isSet(object.variableValue)
        ? VariableValue.fromJSON(object.variableValue)
        : isSet(object.variable_value)
        ? VariableValue.fromJSON(object.variable_value)
        : undefined,
      group: isSet(object.group) ? ConditionGroupReport.fromJSON(object.group) : undefined,
      comparison: isSet(object.comparison) ? ComparisonReport.fromJSON(object.comparison) : undefined,
      date_time_set: isSet(object.dateTimeSet)
        ? DateTimeSetReport.fromJSON(object.dateTimeSet)
        : isSet(object.date_time_set)
        ? DateTimeSetReport.fromJSON(object.date_time_set)
        : undefined,
    };
  },

  toJSON(message: ConditionReport): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = conditionOutcomeToJSON(message.outcome);
    }
    if (message.variable_value !== undefined) {
      obj.variableValue = VariableValue.toJSON(message.variable_value);
    }
    if (message.group !== undefined) {
      obj.group = ConditionGroupReport.toJSON(message.group);
    }
    if (message.comparison !== undefined) {
      obj.comparison = ComparisonReport.toJSON(message.comparison);
    }
    if (message.date_time_set !== undefined) {
      obj.dateTimeSet = DateTimeSetReport.toJSON(message.date_time_set);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConditionReport>, I>>(base?: I): ConditionReport {
    return ConditionReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConditionReport>, I>>(object: I): ConditionReport {
    const message = createBaseConditionReport();
    message.outcome = object.outcome ?? 0;
    message.variable_value = (object.variable_value !== undefined && object.variable_value !== null)
      ? VariableValue.fromPartial(object.variable_value)
      : undefined;
    message.group = (object.group !== undefined && object.group !== null)
      ? ConditionGroupReport.fromPartial(object.group)
      : undefined;
    message.comparison = (object.comparison !== undefined && object.comparison !== null)
      ? ComparisonReport.fromPartial(object.comparison)
      : undefined;
    message.date_time_set = (object.date_time_set !== undefined && object.date_time_set !== null)
      ? DateTimeSetReport.fromPartial(object.date_time_set)
      : undefined;
    return message;
  },
};

function createBaseComparisonReport(): ComparisonReport {
  return { rhs_value: undefined, rhs2_value: undefined };
}

export const ComparisonReport: MessageFns<ComparisonReport> = {
  encode(message: ComparisonReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rhs_value !== undefined) {
      VariableValue.encode(message.rhs_value, writer.uint32(10).fork()).join();
    }
    if (message.rhs2_value !== undefined) {
      VariableValue.encode(message.rhs2_value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComparisonReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseComparisonReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.rhs_value = VariableValue.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.rhs2_value = VariableValue.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ComparisonReport {
    return {
      rhs_value: isSet(object.rhsValue)
        ? VariableValue.fromJSON(object.rhsValue)
        : isSet(object.rhs_value)
        ? VariableValue.fromJSON(object.rhs_value)
        : undefined,
      rhs2_value: isSet(object.rhs2Value)
        ? VariableValue.fromJSON(object.rhs2Value)
        : isSet(object.rhs2_value)
        ? VariableValue.fromJSON(object.rhs2_value)
        : undefined,
    };
  },

  toJSON(message: ComparisonReport): unknown {
    const obj: any = {};
    if (message.rhs_value !== undefined) {
      obj.rhsValue = VariableValue.toJSON(message.rhs_value);
    }
    if (message.rhs2_value !== undefined) {
      obj.rhs2Value = VariableValue.toJSON(message.rhs2_value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ComparisonReport>, I>>(base?: I): ComparisonReport {
    return ComparisonReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ComparisonReport>, I>>(object: I): ComparisonReport {
    const message = createBaseComparisonReport();
    message.rhs_value = (object.rhs_value !== undefined && object.rhs_value !== null)
      ? VariableValue.fromPartial(object.rhs_value)
      : undefined;
    message.rhs2_value = (object.rhs2_value !== undefined && object.rhs2_value !== null)
      ? VariableValue.fromPartial(object.rhs2_value)
      : undefined;
    return message;
  },
};

function createBaseDateTimeSetReport(): DateTimeSetReport {
  return {
    resolved: false,
    name: "",
    iana_timezone: "",
    entry_count: 0,
    specific_dates: undefined,
    days_of_week: undefined,
  };
}

export const DateTimeSetReport: MessageFns<DateTimeSetReport> = {
  encode(message: DateTimeSetReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.resolved !== false) {
      writer.uint32(8).bool(message.resolved);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.iana_timezone !== "") {
      writer.uint32(26).string(message.iana_timezone);
    }
    if (message.entry_count !== 0) {
      writer.uint32(32).int32(message.entry_count);
    }
    if (message.specific_dates !== undefined) {
      SpecificDateSet.encode(message.specific_dates, writer.uint32(42).fork()).join();
    }
    if (message.days_of_week !== undefined) {
      DayOfWeekSet.encode(message.days_of_week, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DateTimeSetReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDateTimeSetReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.resolved = reader.bool();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.name = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.iana_timezone = reader.string();
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.entry_count = reader.int32();
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.specific_dates = SpecificDateSet.decode(reader, reader.uint32());
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.days_of_week = DayOfWeekSet.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DateTimeSetReport {
    return {
      resolved: isSet(object.resolved) ? globalThis.Boolean(object.resolved) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      iana_timezone: isSet(object.ianaTimezone)
        ? globalThis.String(object.ianaTimezone)
        : isSet(object.iana_timezone)
        ? globalThis.String(object.iana_timezone)
        : "",
      entry_count: isSet(object.entryCount)
        ? globalThis.Number(object.entryCount)
        : isSet(object.entry_count)
        ? globalThis.Number(object.entry_count)
        : 0,
      specific_dates: isSet(object.specificDates)
        ? SpecificDateSet.fromJSON(object.specificDates)
        : isSet(object.specific_dates)
        ? SpecificDateSet.fromJSON(object.specific_dates)
        : undefined,
      days_of_week: isSet(object.daysOfWeek)
        ? DayOfWeekSet.fromJSON(object.daysOfWeek)
        : isSet(object.days_of_week)
        ? DayOfWeekSet.fromJSON(object.days_of_week)
        : undefined,
    };
  },

  toJSON(message: DateTimeSetReport): unknown {
    const obj: any = {};
    if (message.resolved !== false) {
      obj.resolved = message.resolved;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.iana_timezone !== "") {
      obj.ianaTimezone = message.iana_timezone;
    }
    if (message.entry_count !== 0) {
      obj.entryCount = Math.round(message.entry_count);
    }
    if (message.specific_dates !== undefined) {
      obj.specificDates = SpecificDateSet.toJSON(message.specific_dates);
    }
    if (message.days_of_week !== undefined) {
      obj.daysOfWeek = DayOfWeekSet.toJSON(message.days_of_week);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DateTimeSetReport>, I>>(base?: I): DateTimeSetReport {
    return DateTimeSetReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DateTimeSetReport>, I>>(object: I): DateTimeSetReport {
    const message = createBaseDateTimeSetReport();
    message.resolved = object.resolved ?? false;
    message.name = object.name ?? "";
    message.iana_timezone = object.iana_timezone ?? "";
    message.entry_count = object.entry_count ?? 0;
    message.specific_dates = (object.specific_dates !== undefined && object.specific_dates !== null)
      ? SpecificDateSet.fromPartial(object.specific_dates)
      : undefined;
    message.days_of_week = (object.days_of_week !== undefined && object.days_of_week !== null)
      ? DayOfWeekSet.fromPartial(object.days_of_week)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
